import * as React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Droppable } from "@hello-pangea/dnd";
import { stageNames, stagePlaceholder } from "./stages";
import RewardCard from "./RewardCard";

const RewardColumn = ({ stage, rewardIds, data }) => {
  const theme = useTheme();
  return (
    <div
      style={{
        flex: 0.4,
        padding: "8px 4px 12px 4px",
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 8,
        margin: theme.spacing(2),
      }}
    >
      <Typography align="center" variant="h6">
        {stageNames[stage]} ({rewardIds?.length})
      </Typography>
      <Droppable droppableId={stage}>
        {(droppableProvided, snapshot) => (
          <div
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
            style={{
              display: "flex",
              flexDirection: "column",
              borderRadius: 8,
              margin: theme.spacing(1),
              padding: theme.spacing(0.5),
              ...(snapshot.isDraggingOver && {
                backgroundColor: theme.palette.secondary.main,
              }),
            }}
          >
            {rewardIds?.length === 0 && (
              <Typography align="center" variant="body1" color="textSecondary">
                {stagePlaceholder[stage]}
              </Typography>
            )}
            {rewardIds.map((id, index) => {
              return (
                <RewardCard
                  key={id}
                  index={index}
                  reward={data.find((d) => d.id === id)}
                />
              );
            })}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default RewardColumn;
